@if(!user()) {
<av-loading-item [icon]="'person'" [textKey]="'shared.general.labels.loading'" />
}
@else {
<div class="layout">
    <av-breadcrumb />
    <app-user-actions />
    <div class="user-content">
        <router-outlet></router-outlet>
    </div>
</div>
}